module.exports = __webpack_public_path__ + "static/img/returned.e44ca884.png";